export default __webpack_public_path__ + "f2d600af80ea057baa2e29674b553bae.png";